import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { MultiviewComponent } from "../../../../common/multiview/multiview.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { SmsTemplateRepositoryService } from "../../../../common/sms/smsTemplateRepository.service";
import { InmediateUnsignedContractsDirectService, UnsignedContractsDirectServiceData } from "../../services/contractsKpi/unsignedContractsDirect.service";
import { ContractDetail, InmediateUnsignedContractsDirectDetailService, UnsignedContractsDirectDetailServiceData } from "../../services/contractsKpi/unsignedContractsDirectDetail.service";
import { ActionResultData } from "../../../../dashboardCommon/components/cardDetails/actionResult.component";
import { ActionColumnData, ActionColumnDefinition, DateColumnDefinition, EmailColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { CellAction, CellActionEvent } from "../../../../dashboardCommon/components/cardDetails/datatableActionCell.component";
import { SendSMSData, SendSMSResult } from "../../../../dashboardCommon/components/cardDetails/sendSMS.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { ContractsDirectDetailData } from "./contractsDirectDetailData";

@Component({
    selector: 'inmediate-unsigned-contracts-direct-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class InmediateUnsignedContractsDirectKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<InmediateUnsignedContractsDirectService, UnsignedContractsDirectServiceData, UnsignedContractsDirectServiceData, InmediateUnsignedContractsDirectDetailService, UnsignedContractsDirectDetailServiceData, ContractsDirectDetailData>
    implements OnDestroy {
    public getClassName() { return "InmediateUnsignedContractsDirectKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: InmediateUnsignedContractsDirectService, detailService: InmediateUnsignedContractsDirectDetailService,
        private smsTemplateRepositoryService: SmsTemplateRepositoryService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: UnsignedContractsDirectServiceData): UnsignedContractsDirectServiceData {
        return data;
    }

    protected getDefaultSummaryData(): UnsignedContractsDirectServiceData {
        let data = new UnsignedContractsDirectServiceData();
        data.consultant = 0;
        data.office = 0;
        data.updateTimestamp = new Date();
        return data;
    }

    protected extractUpdateTime(data: UnsignedContractsDirectServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: UnsignedContractsDirectDetailServiceData, args: any): ContractsDirectDetailData {
        if (data.contracts) {
            if (args && args.filter && args.filter.consultant) {

                let indexTypeContract: number = 1;
                let indexBeginDate: number = 2;
                let indexEndDate: number = 3;

                let columnDefinitions = [
                    new ActionColumnDefinition("Acciones"),
                    new TextColumnDefinition("Tipo", this.descriptionTypeDetailContract(), true),
                    new DateColumnDefinition("Fecha inicio", (data) => data != "---" ? moment(data).format("DD/MM/YYYY") : data, true),
                    new DateColumnDefinition("Fecha fin", (data) => data != "---" ? moment(data).format("DD/MM/YYYY") : data, true),
                    new TextColumnDefinition("Trabajador"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Unidad", null, true),
                    new TextColumnDefinition("Es Web", null, true)
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[8].filterTerm = [consultantName];
                    }
                    if (args.filter.date) {
                        columnDefinitions[indexBeginDate].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                        columnDefinitions[indexEndDate].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];
                for (let contract of data.contracts) {
                    let actions = new ActionColumnData([], null);
                    if (contract.userDocNumber.toUpperCase() == consultantNif) {
                        if (!this.impersonationService.isImpersonating && this.officeSelectorService.selectedOffice.isUserOffice && contract.workerPhone) {
                            actions = new ActionColumnData([new CellAction("SendSms", "Contactar por SMS")], {
                                sendSMS: {
                                    name: contract.workerName,
                                    phone: contract.workerPhone,
                                    email: contract.workerEmail,
                                    nif: contract.workerDocNumber,
                                    id: contract.workerId
                                }
                            });
                        }

                        tabledata.push([
                            actions,
                            contract.type,
                            contract.beginDate,
                            contract.endDate,
                            contract.workerName,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.clientFiscalName,
                            contract.userName,
                            contract.unitName,
                            contract.isWeb
                        ]);
                    }
                    else {
                        tabledata2.push([
                            actions,
                            contract.type,
                            contract.beginDate,
                            contract.endDate,
                            contract.workerName,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.clientFiscalName,
                            contract.userName,
                            contract.unitName,
                            contract.isWeb
                        ]);
                    }
                }

                let arrayOrdenado = tabledata.concat(tabledata2);

                this.updateDatesByTypeContract(arrayOrdenado, indexTypeContract, indexBeginDate, indexEndDate);

                return new ContractsDirectDetailData(columnDefinitions, arrayOrdenado);
            } else {

                let indexTypeContract: number = 1;
                let indexBeginDate: number = 4;
                let indexEndDate: number = 5;

                let columnDefinitions = [
                    new ActionColumnDefinition("Acciones"),
                    new TextColumnDefinition("Tipo", this.descriptionTypeDetailContract(), true),
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Unidad", null, true),
                    new DateColumnDefinition("Fecha inicio", (data) => data != "---" ? moment(data).format("DD/MM/YYYY") : data, true),
                    new DateColumnDefinition("Fecha fin", (data) => data != "---" ? moment(data).format("DD/MM/YYYY") : data, true),
                    new TextColumnDefinition("Trabajador"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Es Web", null, true)
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.userDocNumber == consultantNif) || { name: null }).name;
                        columnDefinitions[2].filterTerm = [consultantName];
                    }

                    if (args.filter.date) {
                        columnDefinitions[indexBeginDate].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                        columnDefinitions[indexEndDate].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                    };
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let contract of data.contracts) {
                    let actions = new ActionColumnData([], null);

                    if (!this.impersonationService.isImpersonating && this.officeSelectorService.selectedOffice.isUserOffice && contract.workerPhone) {
                        actions = new ActionColumnData([new CellAction("SendSms", "Contactar por SMS")], {
                            sendSMS: {
                                name: contract.workerName,
                                phone: contract.workerPhone,
                                email: contract.workerEmail,
                                nif: contract.workerDocNumber,
                                id: contract.workerId
                            }
                        });
                    }
                    tabledata.push([
                        actions,
                        contract.type,
                        contract.userName,
                        contract.unitName,
                        contract.beginDate,
                        contract.endDate,
                        contract.workerName,
                        contract.workerPhone,
                        contract.workerEmail,
                        contract.clientFiscalName,
                        contract.isWeb
                    ]);

                }

                let arrayOrdenado = tabledata.concat(tabledata2);

                this.updateDatesByTypeContract(arrayOrdenado, indexTypeContract, indexBeginDate, indexEndDate);

                return new ContractsDirectDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: ContractDetail[]): { userDocNumber: string, name: string }[] {
        let userDocNumbers: { userDocNumber: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!userDocNumbers.find(y => x.userDocNumber.toUpperCase() == y.userDocNumber)) userDocNumbers.push({ userDocNumber: x.userDocNumber.toUpperCase(), name: x.userName });
            })
        }

        return userDocNumbers;
    }

    /**
     * Descripcion del tipo de detalle de contrato
     * @param data Informe del tipo de contrato
     * @returns  Descripcion del tipo de detalle de contrato
     */
    private descriptionTypeDetailContract() {
        return (data: string) => data == "C" ? "Contrato" : (data == 'CD' ? "Contrato paraguas FD" : (data == 'FC' ? "Fin contrato" : "Prórroga"));
    }

    /**
     * Actualizar las fechas del contrato por el tipo de contrato
     * @param tabledata Objetos con los datos del contrato
     * @param indexTypeContract Indice del tipo de contrato
     * @param indexBeginDate Indice de la fecha de inicio
     * @param indexEndDate Indice de la fecha fin
     */
    private updateDatesByTypeContract(tabledata: any[], indexTypeContract: number, indexBeginDate: number, indexEndDate: number) {
        tabledata.forEach(data => {
            if (data[indexTypeContract] == 'FC') {
                data[indexBeginDate] = "---";
            }
            else {
                data[indexEndDate] = "---";
            }
        });
    }

    protected getDefaultDetailData(): ContractsDirectDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Tipo", this.descriptionTypeDetailContract(), true),
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Unidad", null, true),
            new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY"), true),
            new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
            new TextColumnDefinition("Trabajador"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new TextColumnDefinition("Cliente", null, true),
            new TextColumnDefinition("Es Web", null, true)
        ];

        return new ContractsDirectDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }

    public handleDatatableCellAction(event: CellActionEvent, multiview: MultiviewComponent) {
        multiview.setViewWithContext(1, {
            sendSMSData: new SendSMSData(event.data.sendSMS.name, event.data.sendSMS.phone, event.data.sendSMS.email, this.smsTemplateRepositoryService.inmediateUnsignedContractsDirectSmsText, (result) => {
                switch (result) {
                    case SendSMSResult.Succedded: {
                        this.logger.traceActivity("SMS from:{0} to:{1} Nif: {2} Id: {3} with phone number:{4}".format(this.impersonationService.getEmail(), event.data.sendSMS.name, event.data.sendSMS.nif, event.data.sendSMS.id, event.data.sendSMS.phone));
                        multiview.setViewWithContext(2, {
                            actionResultData: new ActionResultData("Mensaje se ha enviado correctamente", true, 2000, () => {
                                multiview.setView(0);
                            })
                        });
                        break;
                    }

                    case SendSMSResult.Failed: {
                        multiview.setViewWithContext(2, {
                            actionResultData: new ActionResultData("No se ha podido enviar el mensaje", false, 2000, () => {
                                multiview.setView(0);
                            })
                        });
                        break;
                    }

                    case SendSMSResult.Cancelled: {
                        multiview.setView(0);
                        break;
                    }
                }
            })
        });
    }
}
